export default "__VITE_ASSET__JcTWCKcX__"